/**
     * Codifica string utilizando caracteres que pueden ser interpretados por HTML.
     * @param {String} data - Texto original sin codificar.
     * @returns {String} String codificado con caracteres equivalentes en HTML.
    */
function htmlEncode(data) {
    return data
         .replace(/&/g, "&#x26;")
         .replace(/</g, "&#x3c;")
         .replace(/>/g, "&#x3e;")
         .replace(/"/g, "&#x22;")
         .replace(/'/g, "&#x27;");
}
export default htmlEncode;